"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponseHeaders = exports.getQueryString = exports.getDefaultAxiosHeaders = exports.getDefaultAxiosMethod = exports.getDefaultTimeout = exports.constructRequestConfig = exports.constructResponse = void 0;
var constructResponse = function (args) {
    var response = {
        headers: args.headers,
        statusCode: args.statusCode,
    };
    if (args.body) {
        response.body = args.body;
    }
    return response;
};
exports.constructResponse = constructResponse;
var constructRequestConfig = function (args) {
    var config = {
        baseURL: args.baseURL,
        url: args.url,
        method: args.method ? args.method : (0, exports.getDefaultAxiosMethod)(),
        timeout: args.timeout ? args.timeout : (0, exports.getDefaultTimeout)(),
    };
    if (args.headers) {
        config.headers = args.headers;
    }
    if (args.params) {
        config.params = args.params;
    }
    if (args.data) {
        config.data = args.data;
    }
    if (args.transformRequest) {
        config.transformRequest = args.transformRequest;
    }
    return config;
};
exports.constructRequestConfig = constructRequestConfig;
var getDefaultTimeout = function () {
    return 5000;
};
exports.getDefaultTimeout = getDefaultTimeout;
var getDefaultAxiosMethod = function () {
    return 'post';
};
exports.getDefaultAxiosMethod = getDefaultAxiosMethod;
var getDefaultAxiosHeaders = function () {
    return {
        'Content-Type': 'application/x-www-form-urlencoded',
    };
};
exports.getDefaultAxiosHeaders = getDefaultAxiosHeaders;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getQueryString = function (data) {
    return new URLSearchParams(data).toString();
};
exports.getQueryString = getQueryString;
var getResponseHeaders = function () {
    return {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    };
};
exports.getResponseHeaders = getResponseHeaders;
